export const escalateButtonIconStyles = {
  fontSize: '16px',
};
